import { TicketType } from "../products/types/ceremony-ticket.js";
import { z } from "zod";
export const ticketSchema = z.object({
    PK: z.string(),
    SK: z.string(),
    GSI1_PK: z.string(),
    GSI1_SK: z.string(),
    GSI2_PK: z.string(),
    GSI2_SK: z.string(),
    awardYear: z.number(),
    candidateName: z.string(),
    holder: z.object({
        email: z.string(),
        firstName: z.string(),
        lastName: z.string(),
        mobile: z.string(),
    }),
    night: z.number(),
    optionType: z.enum([TicketType.GeneralCeremonyTicket, TicketType.VIPCeremonyTicket]),
    drawingsWon: z.array(z.string()).optional(),
    drawingTime: z.string().optional(),
    qrCodeUrl: z.string(),
    scanned: z.string().optional(),
    scannedManual: z.boolean().optional(),
    sent: z.number().optional(),
    ticketNumber: z.number(),
    timestamp: z.string(),
});
// export interface Ticket {
//   PK: string;
//   SK: string;
//   GSI1_PK: string;
//   GSI1_SK: string;
//   GSI2_PK: string;
//   GSI2_SK: string;
//   awardYear: number;
//   candidateName: string;
//   holder: {
//     email: string;
//     firstName: string;
//     lastName: string;
//     mobile: string;
//   };
//   night: number;
//   optionType: keyof typeof TicketType;
//   drawingsWon?: Array<string>;
//   drawingTime?: string;
//   qrCodeUrl: string;
//   scanned?: string;
//   scannedManual?: boolean;
//   sent?: number;
//   ticketNumber: number;
//   timestamp: string;
// }
export function isTicket(item) {
    return !!item && typeof item === "object" && "PK" in item;
}
//# sourceMappingURL=types.js.map